// This file is now handled by src/services/api.ts
// Keeping for backwards compatibility

import { storeApi } from "./api";

export const getAllStores = async () => {
  return await storeApi.getAll();
};

export const getStoreById = async (id: number) => {
  return await storeApi.getById(id);
};

export const createStore = async (storeData: Record<string, unknown>) => {
  return await storeApi.create(storeData);
};

export const updateStore = async (id: number, storeData: Record<string, unknown> | FormData) => {
  return await storeApi.update(id, storeData as any);
};

export const deleteStore = async (id: number) => {
  return await storeApi.delete(id);
};

export default storeApi;
